import { render, staticRenderFns } from "./SSearchByOV.vue?vue&type=template&id=0e4782e4"
import script from "./SSearchByOV.vue?vue&type=script&lang=js"
export * from "./SSearchByOV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports